module.exports = __webpack_public_path__ + "static/img/style-home.88b37756.png";